module.exports = __webpack_public_path__ + "static/img/home_advice.f9ea8ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_advice.jpg
// module id = 4cy+
// module chunks = 1